// extracted by css-extract-rspack-plugin
export default {"sidePanel":"side-panel_sidePanel__7oiCd","slideIn":"side-panel_slideIn__ZCZ1p","footer":"side-panel_footer__P67ka","header":"side-panel_header__T5drD"};